import axios from 'axios'
import { getToken } from '@/utils/auth.js'
axios.defaults.headers.post['Content-Type'] = 'application/json'
//创建axios实例
const instance = axios.create({
    // baseURL: "http://192.168.1.170:8201",
    // baseURL: "http://127.0.0.1:8201",
    // baseURL: "http://192.168.2.100:8201",
    // baseURL: "http://192.168.2.164:8201",
    baseURL: "https://www.agougoubuy.cn",
    timeout: 10000
})

//axios拦截器
instance.interceptors.request.use(config => {
    // console.log(config)
    //1.比如config中的一些信息不符合服务器要求
    //2.比如每次发送网络请求时,都希望在界面显示换一个请求图标
    //3.某些网络请求(比如登录(token)),必须携带一些特殊信息
    if (getToken()){
        config.headers['Authorization'] = getToken(); // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    return config
}, err => {
    console.log(err)
});

export default {
    fetchGet (url, params = {}) {
        return new Promise((resolve, reject) => {
            instance.get(url, params).then(res => {
                resolve(res.data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    fetchPost (url, params = {}) {
        return new Promise((resolve, reject) => {
            instance.post(url, params).then(res => {
                resolve(res.data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    fetchPostQuery (url, params = {}) {
        return new Promise((resolve, reject) => {
            instance.post(url,{}, {params}).then(res => {
                resolve(res.data)
            }).catch(error => {
                reject(error)
            })
        })
    }
}
